import React from "react";

// The folded map drawn on the landing page's "Explore the map" button, shared so every
// way into the map looks the same. size is in pixels (20 matches MUI's fontSize="small").
const MapIcon = ({size = 20, className}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
        <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2z"/><path d="M9 4v14M15 6v14"/>
    </svg>
);

export default MapIcon;
